import React from "react";
import { Outlet } from "react-router-dom";
import { ProCard } from "@ant-design/pro-components";
import ApplicationStore from "../../store/ApplicationStore";
import DemoFooter from "components/footers/DemoFooter";
import DemoNavbar from "components/navbars/DemoNavbar";

// const img = require("assets/img/pages/photo-15.jpg")

const MainLayout = () => {
  // const navigate = useNavigate()
  // const [pathname, setPathname] = useState("/")

  // const userAuth = ApplicationStore((state) => state.userAuth)
  const userMenu = ApplicationStore((state) => state.menu);
  // const setMenu = ApplicationStore((state) => state.setCurrentMenu)

  return (
    <>
      <DemoNavbar type="transparent" menu={userMenu} />
      <div className="wrapper">
        <div className="section-shaped my-0 skew-separator skew-mini">
          <div className="page-header page-header-small header-filter">
            <div className="page-header-image"></div>
          </div>
        </div>
        <div className="upper" style={{ marginTop: -250 }}>
          <ProCard
            style={{
              zIndex: 10,
              minHeight: 800,
              background: "linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)",
              // backgroundImage:
              //   "url(" + require("assets/img/ill/register_bg.png") + ")",
            }}
          >
            <div className="pb-2">
              <Outlet />
            </div>
          </ProCard>
        </div>
        <DemoFooter />
      </div>
    </>
  );
};

export default MainLayout;
